export const name = 'ooiTpaSharedConfig' as const
export const OoiTpaSharedConfigSymbol = Symbol('ooiTpaSharedConfig')
export const OOICompDataSymbol = Symbol('OOICompData')
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
